export default "__VITE_ASSET__BJHPcbg___"